import './styles/normalize.scss';
import './styles/variables.scss';
import './styles/common.scss';
import './styles/grid.scss';


import '../templates/components/components';
import '../templates/modal/modal';
import '../templates/pages/pages';

import 'toastr/toastr.scss';

//if (!window.location.pathname.includes('/editor/')) {
//    Array.from(document.querySelectorAll('pre')).forEach(item => {
//        if (!item.children.length || item.children[0].tagName !== 'CODE') {
//            const code = document.createElement('CODE');
//            code.innerHTML = item.innerHTML;
//            code.className = item.className;
//            item.innerHTML = '';
//            item.appendChild(code);
//        }
//    });
//}
//
Array.from(document.querySelectorAll('pre code')).forEach(item => {
    let type = item.className;

    if (type === 'html') {
       type = 'xml'
    }

    if (hljs.listLanguages().includes(type)) {
        let code = item.innerHTML;

        code = code.replace(new RegExp('&lt;', 'g'), '<');
        code = code.replace(new RegExp('&gt;', 'g'), '>');

        item.innerHTML = hljs.highlightAuto(code).value;
    }
});
